module.exports = __webpack_public_path__ + "4eefbcf5cc677eab4050e1c69502c56f.jpg";